import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#f93";
function VERI({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M4.5 6q1.243.003 2.484 0l1.568 8.385q.038.185.087.368c.123-.488.2-.986.303-1.478L10.37 6h2.403q-1.321 5.888-2.645 11.774H7.145L4.5 6.008zm9.236 3.7c.522-.658 1.358-.956 2.163-1.008.795-.056 1.652.016 2.325.49.596.417.924 1.122 1.079 1.824.188.879.198 1.782.197 2.677h-4.402c.003.662-.038 1.346.183 1.98.107.312.308.623.626.736.339.11.747.038.994-.235.33-.373.4-.897.471-1.376h1.998c-.045.795-.192 1.635-.712 2.26-.522.65-1.364.915-2.16.947-.866.033-1.806-.085-2.496-.668-.64-.534-.92-1.382-1.032-2.194a16.3 16.3 0 01-.065-2.822c.07-.916.236-1.887.83-2.613zm1.705.933c-.34.49-.35 1.122-.344 1.7h2.275c-.036-.55-.032-1.13-.28-1.633-.307-.621-1.279-.624-1.65-.066z" /></Svg>;
}
VERI.DefaultColor = DefaultColor;
export default VERI;